/* eslint-disable max-len */
import React from 'react';

export function SendEquipmentIcon() {
  return (
    <svg fill="#000000" width="21" height="21" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg" data-iconid="340135" data-svgname="Delivery">
      <defs />
      <rect x="4" y="16" width="12" height="2" />
      <rect x="2" y="11" width="10" height="2" />
      <path d="M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z" />
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" style={{ fill: 'none' }} width="32" height="32" />
    </svg>
  );
}
